<template>
  <div class="wrap brand-home-wrap flex-column">
    <topLink></topLink>
    <!-- 子品牌logo -->
    <div class="logo">
      <div class="img-box">
        <v-image
          :imagePath="shopDetail.imagePath && shopDetail.imagePath.imagePath"
          :height="42"
        ></v-image>
      </div>
      <!-- 搜索框 -->
      <div class="input-box" :class="{ fixed: isFixed }">
        <input
          @change=""
          class="serarch-input"
          type="text"
          name=""
          :placeholder="shopDetail.storeName"
          @click="jumpSearch"
        />
      </div>
    </div>
    <div class="flex-item homeWrapper" ref="homeWrapper">
      <!-- banner广告轮播 -->
      <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- 这部分放你要渲染的那些内容 -->
          <swiper-slide
            v-for="(swiperShow, swiperIndex) in bannerDeatilList"
            :key="swiperIndex"
          >
            <div
              class="img-box"
              @click="goPage(swiperShow.linkType, swiperShow.linkTarget)"
            >
              <!-- <imgs :imagePath="require('@assets/zyImages/u276.jpeg')"></imgs> -->
              <v-image
                :imagePath="
                  swiperShow.imagePath && swiperShow.imagePath.imagePath
                "
              ></v-image>
            </div>
          </swiper-slide>
          <!-- 这是轮播的小圆点 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 优惠券 -->
      <div class="coupon" v-if="couponsList && couponsList.length">
        <div
          class="coupon-recommend"
          :style="
            'background: url(' +
            backgroundImage +
            ') no-repeat;background-size: 100% 100%;'
          "
        >
          <swiper :options="comSwiperOption" ref="mySwiper2">
            <!-- 这部分放你要渲染的那些内容 -->
            <swiper-slide
              v-for="(item, index) in couponsList"
              :key="index"
              class="coupon-item"
            >
              <div
                class="coupon-content"
                @click="
                  receiveCouponFn(item.couponId, item.couponType, item.isGet)
                "
              >
                <div
                  class="coupon-left"
                  :class="{
                    couponColor: item.couponType == 1,
                    redpacketColor: item.couponType == 2,
                    finishColor: item.isGet == 1,
                  }"
                >
                  <p class="amount" v-if="item.couponCate != 3">
                    <samp>¥</samp>
                    {{ item.couponAmount }}
                  </p>
                  <p class="amount" v-if="item.couponCate == 3">
                    {{ item.couponDiscount | discount }}
                    <samp>折</samp>
                  </p>
                  <p class="limit" v-if="item.couponType == 1">
                    {{
                      item.useAmount == 0
                        ? "不限制"
                        : "满" + item.useAmount + "可用"
                    }}
                  </p>
                  <p class="limit" v-if="item.couponType == 2">
                    {{
                      "剩余" +
                      (parseInt(item.sendNum) - parseInt(item.recivedNum)) +
                      "个红包"
                    }}
                  </p>
                </div>
                <div
                  class="coupon-right verticalM"
                  :class="{
                    coupons: item.couponType == 1,
                    redpacket: item.couponType == 2,
                    finish: item.isGet == 1,
                  }"
                >
                  <span class="verticalM-box" v-if="item.isGet != 1">
                    立
                    <br />
                    即
                    <br />
                    领
                    <br />
                    取
                  </span>
                  <span class="verticalM-box" v-if="item.isGet == 1">
                    已
                    <br />
                    领
                    <br />
                    取
                  </span>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 广告 三个促销-->
      <mu-flexbox class="grid-three">
        <!-- DIY暂时屏蔽 -->
        <!-- <mu-flexbox-item class="flex-demo">
            <a class="verticalM"><span class="verticalM-box">DIY专区</span></a>
          </mu-flexbox-item> -->
        <mu-flexbox-item
          class="flex-demo"
          v-for="(promotionShop3, promotion3Index) in promotionsShopList33"
          @click="
            goPage(
              promotionShop3.cates.linkType,
              promotionShop3.cates.linkTarget
            )
          "
          :key="promotion3Index"
        >
          <v-image
            :imagePath="
              promotionShop3.imagePath && promotionShop3.imagePath.imagePath
            "
          ></v-image>
        </mu-flexbox-item>
      </mu-flexbox>
      <!-- 一个图 -->
      <mu-flexbox
        class="grid-one"
        v-for="(promotionShop44, promotion44Index) in promotionsShopList44"
        @click="
          goPage(
            promotionShop44.cates.linkType,
            promotionShop44.cates.linkTarget
          )
        "
        :key="promotion44Index"
      >
        <mu-flexbox-item class="flex-demo">
          <v-image
            :imagePath="
              promotionShop44.imagePath && promotionShop44.imagePath.imagePath
            "
          ></v-image>
        </mu-flexbox-item>
      </mu-flexbox>
      <!-- 轮播图Banner图2 -->
      <!-- <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="promotionShopBanner,promotionBannerIndex in promotionsShopListBanner" :key="promotionBannerIndex">
            <div class="img-box" @click="linkFn(promotionShopBanner.linkType,promotionShopBanner.linkTarget)">
              <imgs :imagePath="require('@assets/zyImages/u276.jpeg')"></imgs>
              <v-image :imagePath="promotionShopBanner.imagePath && promotionShopBanner.imagePath.imagePath"></v-image>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div> -->
      <div class="banner bannerTwo">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- 这部分放你要渲染的那些内容 -->
          <swiper-slide
            v-for="(
              promotionShopBanner, promotionBannerIndex
            ) in promotionsShopListBanner"
            :key="promotionBannerIndex"
          >
            <div
              class="img-box"
              @click="
                goPage(
                  promotionShopBanner.linkType,
                  promotionShopBanner.linkTarget
                )
              "
            >
              <!-- <imgs :imagePath="require('@assets/zyImages/u276.jpeg')"></imgs> -->
              <v-image
                :imagePath="
                  promotionShopBanner.imagePath &&
                  promotionShopBanner.imagePath.imagePath
                "
              ></v-image>
            </div>
          </swiper-slide>
          <!-- 这是轮播的小圆点 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 尾巴图片 -->
      <mu-flexbox
        class="grid-one grid-one-bannerM"
        v-for="(promotionShop66, promotion66Index) in promotionsShopList66"
        :key="promotion66Index"
      >
        <mu-flexbox-item class="flex-demo">
          <v-image
            :imagePath="
              promotionShop66.imagePath && promotionShop66.imagePath.imagePath
            "
          ></v-image>
        </mu-flexbox-item>
      </mu-flexbox>
      <!-- 子品牌部分产品  跳转/main/search  商品楼层：品牌分类 -->
      <div
        class="brand-product"
        v-for="(shopSetList, setIndex) in floorMsg"
        v-if="floorMsg[0].floorInfo.goods.length != 0"
      >
        <a
          class="header"
          @click="
            goPage(shopSetList.floorInfo.linkType, shopSetList.floorInfo.cateId)
          "
        >
          <span class="floatL brandName">
            {{ shopSetList.floorInfo && shopSetList.floorInfo.cateName }}
          </span>
          <span class="floatR arrow">更多</span>
          <div class="clearfix"></div>
        </a>
        <div class="product">
          <div
            class="product-item square"
            v-for="(shopShow, shopIndex) in shopSetList.floorInfo.goods"
          >
            <v-image
              :width="250"
              :height="250"
              :titleText="shopShow.goodsName"
              :imagePath="shopShow.imagePath && shopShow.imagePath.imagePath"
              :moneyText="
                shopShow.goodsPrice > 0
                  ? shopShow.goodsPrice
                  : shopShow.priceDesc || ''
              "
              :orginalCost="shopShow.unitPrice"
              @eventclick="viewGoodsDetail(shopShow)"
            >
              <template slot="money">
                {{
                  shopShow.goodsPrice > 0
                    ? shopShow.goodsPrice
                    : shopShow.priceDesc
                }}
              </template>
              <template slot="orginalCost">{{ shopShow.unitPrice }}</template>
            </v-image>
          </div>
        </div>
        <div
          class="banner-product"
          v-if="shopSetList.itemType == 99"
          v-for="floorBox in shopSetList"
        >
          <v-image
            :imagePath="
              floorBox.floorInfo &&
              floorBox.floorInfo.imagePath &&
              floorBox.floorInfo.imagePath.imagePath
            "
            @eventclick="viewAdDetail"
            :eventparam="item"
          ></v-image>
        </div>
      </div>
    </div>
    <mu-toast
      v-if="toast.toast"
      :message="toast.messageTip"
      class="custom-toast"
    />
    <!-- <empty imgpath="/static/images/empty_invoice_3x.png" emptytext="您还没有发票信息" v-if="1"></empty> -->
  </div>
</template>
<script type="text/javascript">
import topLink from "@components/topLink/topLink";
import imgs from "@components/image/image";
import image from "@components/image/image";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import empty from "@components/empty/empty";
import { mapActions, mapGetters } from "vuex";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        /*notNextTick: true, */
        pagination: ".swiper-pagination",
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
      },
      scrolled: 0, //滚动距离
      isFixed: false,
      linkTarget: null, //店铺id
      shopDetail: {}, //存放店铺详情
      bannerDeatilList: [], //获取到的banner图
      promotionsShopList33: [], //获取促销列表
      promotionsShopList44: [], //获取促销列表
      promotionsShopListBanner: [], //获取促销列表
      promotionsShopList66: [], //获取促销列表
      floorMsg: [], //获取到的楼层信息
      comSwiperOption: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false,
      },
      couponsList: [], //优惠券和红包列表
      toast: {
        toast: false,
        messageTip: "",
      },
      backgroundImage: "/static/images/get_coupon_bg@3x.png",
      // linkTarget: this.$route.query.linkTarget, //跳转搜索
      //linkType: this.$route.query.linkType, //跳转搜素需要的
    };
  },
  updated() {
    if (!storage.local.get("savePosition")) {
      return;
    }
    this.$nextTick(function () {
      this.$refs.homeWrapper.scrollTop = storage.local.get("savePosition");
      setTimeout(() => {
        storage.local.remove("savePosition");
      }, 500);
    });
  },
  watch: {
    scrolled() {
      if (this.scrolled > 0) {
        this.isFixed = true;
        return;
      }

      this.isFixed = false;
    },
  },
  methods: {
    ...mapActions({
      getStoreBaseInfo: "getStoreBaseInfo", //获取店铺详细信息
      getStoreBanner: "getStoreBanner", //获取店铺Banner图
      getStorePromotions: "getStorePromotions", //获取促销广告
      getStoreFloorInfo: "getStoreFloorInfo", //获取楼层数据
      getListStoreCoupons: "getListStoreCoupons", //获取优惠券和红包列表
      receiveCoupon: "receiveCoupon", //领取优惠券或者红包
    }),
    goPage(linkType, linkTarget) {
      storage.local.set("savePosition", this.$refs.homeWrapper.scrollTop);
      this.linkFn(linkType, linkTarget);
    },
    //获取优惠券和红包列表
    getListStoreCoupon() {
      this.getListStoreCoupons(this.linkTarget)
        .then((res) => {
          this.couponsList = res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //领取优惠券
    receiveCouponFn(couponId, couponType, isGet) {
      if (isGet == 1) {
        return;
      }
      this.receiveCoupon([couponId, couponType])
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.toast.toast = true;
            this.toast.messageTip = res.message || "领取成功";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
            this.getListStoreCoupon();
          } else {
            this.toast.toast = true;
            this.toast.messageTip = res.message || "领取失败，请稍后重试";
            setTimeout(() => {
              this.toast.toast = false;
            }, 1500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //搜索跳转
    jumpSearch() {
      let linkTargetMsg = this.$route.query.linkTarget;
      let linkTypeMsg = this.$route.query.linkType;
      storage.local.set("savePosition", this.$refs.homeWrapper.scrollTop);
      this.$router.push({
        path:
          "/main/search?linkTarget=" +
          linkTargetMsg +
          "&linkType=" +
          linkTypeMsg +
          "&keyWord=",
      });
    },
    //获取滚动的距离
    onScroll() {
      this.scrolled = document.querySelectorAll(".homeWrapper")[0].scrollTop;
    },
    //调用店铺详情api
    getStoreBaseInfoMsg(linkTarget) {
      this.getStoreBaseInfo(linkTarget).then((res) => {
        this.shopDetail = res;
      });
    },
    //获取店铺Banner图;
    getStoreBannerMsg(linkTarget) {
      this.getStoreBanner([linkTarget, 4]).then((res) => {
        this.bannerDeatilList = res;
      });
    },
    //获取促销广告1-4条
    getStorePromotionsMsg(linkTarget, promType) {
      this.getStorePromotions([linkTarget, promType, 4]).then((res) => {
        if (promType == 3) {
          this.promotionsShopList33 = res;
        } else if (promType == 4) {
          this.promotionsShopList44 = res;
        } else if (promType == 5) {
          this.promotionsShopListBanner = res;
        } else if (promType == 6) {
          this.promotionsShopList66 = res;
        } else if (promType == 8) {
          if (res && res[0] && res[0].imagePath && res[0].imagePath.imagePath) {
            this.backgroundImage =
              Constant.imgBaseUrl +
              "/" +
              (res && res[0] && res[0].imagePath && res[0].imagePath.imagePath);
          }
        }
      });
    },
    //获取店铺楼层信息
    getStoreFloorInfoMsg(linkTarget, appType) {
      this.getStoreFloorInfo([linkTarget, appType]).then((res) => {
        this.floorMsg = res;
        //console.log("结果", res);
      });
    },
    //浏览商品详情
    viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        storage.local.set("savePosition", this.$refs.homeWrapper.scrollTop);
        this.$router.push({
          path: "/main/goodsDetail?goodsId=" + goods.goodsId,
        });
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      /* console.log(this.$refs);*/
      document
        .querySelectorAll(".homeWrapper")[0]
        .addEventListener("scroll", this.onScroll);
    });

    this.getListStoreCoupon();
  },
  created() {
    this.linkTarget = this.$route.query.linkTarget; //获取店铺ID
    this.getStoreBaseInfoMsg(this.linkTarget); //获取点店铺详细
    this.getStoreBannerMsg(this.linkTarget); //获取店铺banner图
    this.getStorePromotionsMsg(this.linkTarget, 3); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 4); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 5); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 6); //获取店铺促销商品
    this.getStoreFloorInfoMsg(this.linkTarget, 4); //获取到的楼层信息
    this.getStorePromotionsMsg(this.linkTarget, 8); //获取到的楼层信息
  },
  components: {
    topLink,
    imgs,
    swiper,
    swiperSlide,
    "v-image": image,
    empty,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.brand-home-wrap {
  /* .homeWrapper {
    position: relative;
  } */
  .serarch-input {
    display: block;
    width: 93%;
    height: 0.7rem;
    margin: 0 auto;
    border-radius: 0.675rem;
    color: #fff;
    @include font-dpr(13.5px);
    @include sInput(red, center, #fff);
    background: url(/static/images/productList_search_white@3x.png) no-repeat
      0.25rem center;
    background-size: 0.45rem;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .input-box {
    width: 100%;
    padding: 0.1rem 0;
    position: absolute;
    top: 100%;
    margin-top: -2px;
    z-index: 2;
    &.fixed {
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
      .serarch-input {
        @include sInput(red, center, #999999);
        color: #999999;
        background: url(/static/images/productList_search@3x.png) no-repeat
          0.25rem center;
        background-size: 0.45rem;
        background-color: rgba(239, 239, 239, 1);
      }
    }
  }
  .logo {
    //height: 1.05rem;
    text-align: center;
    background: #fff;
    position: relative;
    &:before,
    &:after {
      content: "";
      display: inline-block;
      width: 28%;
      height: 0.05rem;
      position: absolute;
      background: #004c56;
      top: 50%;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
    .img-box {
      vertical-align: top;
      display: block;
      height: 100%;
      overflow: hidden;
      margin: 0 auto;
      width: 37%; //height: 42px;
    }
  }
  .swiper-container {
    //height: 100%;
  }
  .banner {
    /*height: 4.4rem;*/
    &.bannerTwo {
      margin-top: 0.075rem;
    }
    .swiper-pagination {
      width: 100%;
      bottom: 0.275rem;
      text-align: center;
      > span {
        width: 0.15rem;
        height: 0.15rem;
        margin: 0 0.075rem;
        border-radius: 50%;
        background: #fff;
        opacity: 1;
        &.swiper-pagination-bullet-active {
          width: 0.3rem;
          border-radius: 0.2rem;
        }
      }
    }
  }
  .grid-three {
    /*height: 1.575rem;*/
    margin-top: 0.075rem;
    overflow: hidden;
    .flex-demo {
      height: 100%;
      > a {
        display: block;
        width: 100%;
        height: 100%;
        background: #fff;
        text-align: center;
        > span {
          @include font-dpr(20px);
          color: #ffcb00;
        }
      }
    }
  }
  .grid-one {
    overflow: hidden;
    margin-top: 0.075rem;
    &.grid-one-bannerM {
      height: 2.5rem;
    }
    &.grid-one-bannerB {
      width: 100%; //height: 2.7rem;
      .swiper-pagination {
        width: 100%;
        bottom: 0.275rem;
        text-align: center;
        > span {
          width: 0.15rem;
          height: 0.15rem;
          margin: 0 0.075rem;
          border-radius: 50%;
          background: #fff;
          opacity: 1;
          &.swiper-pagination-bullet-active {
            width: 0.3rem;
            border-radius: 0.2rem;
          }
        }
      }
      .swiper-slide-prev {
        width: 100%;
      }
    }
  }
  .brand-product {
    margin-bottom: 0.2rem;
    .header {
      display: block;
      padding: 0.35rem 0.1rem;
      background: #fff;
      @include font-dpr(13px);
      > span {
        line-height: 0.55rem;
      }
      > .brandName {
        padding-left: 0.125rem;
        @include font-dpr(18px);
        color: #444444;
      }
      > .arrow {
        color: #808080;
        padding-right: 0.375rem;
        position: relative;
        @include arrow(#808080, right, 0.25rem, 1px, 0.075rem);
      }
    }
    .product {
      padding: 0 0.05rem;
      background: #fff;
      .product-item {
        display: inline-block;
        width: 50%;
        vertical-align: top;
        .image-wrap {
          padding: 0 0.05rem;
        }
      }
    }
    .banner-product {
      margin-top: 0.2rem;
      background: #bdbdbd;
    }
  }
  .coupon {
    margin: 0.1rem 0 0.25rem 0;
    .coupon-recommend {
      padding-top: 0.5rem;
      padding-bottom: 0.1rem;
      .coupon-item {
        display: inline-block;
        padding: 0 0.1rem;
        cursor: pointer;
        line-height: 1;
        overflow: hidden;
        .coupon-content {
          display: inline-block;
          width: 100%;
          background: #ffffff;
          box-shadow: 0 0.05rem 0.1rem 0 rgba(0, 0, 0, 0.1);
          border-radius: 0.1rem;
          font-size: 0;
          position: relative;
          .coupon-left,
          .coupon-right {
            display: inline-block;
            height: 100%;
            vertical-align: top;
            white-space: normal;
            text-align: center;
          }
          .coupon-left {
            width: 74%;
            .amount {
              margin-top: 0.225rem;
              @include font-dpr(24px);
              font-weight: 700;
              > samp {
                @include font-dpr(14px);
              }
            }
            .limit {
              margin: 0.275rem 0 0.2rem 0;
              @include font-dpr(12px);
            }
            &.couponColor {
              color: #ffcb76;
            }
            &.redpacketColor {
              color: #ff6868;
            }
            &.finishColor {
              color: #b7b7b7;
            }
          }
          .coupon-right {
            width: 26%;
            position: absolute;
            top: 0;
            bottom: -0.1rem;
            right: -0.1rem;
            @include font-dpr(12px);
            color: #fff;
            &.coupons {
              background: url(/static/images/CombinedShape_yellow@3x.png)
                no-repeat;
              background-size: auto 100%;
            }
            &.redpacket {
              background: url(/static/images/CombinedShape_red@3x.png) no-repeat;
              background-size: auto 100%;
            }
            &.finish {
              background: url(/static/images/CombinedShape_gray@3x.png)
                no-repeat;
              background-size: auto 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// brandHome.vue?791b116e